module.exports = __webpack_public_path__ + "img/瓢虫.ce170402.gif";